/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
/**
 * @author eric.wittmann@gmail.com
 * @class
 */
export class AaiRedisChannelBinding {}
AaiRedisChannelBinding["__class"] = "io.apicurio.datamodels.asyncapi.models.bindings.AaiRedisChannelBinding";



